module.exports = __webpack_public_path__ + "static/blogging-7d5ecf3e106b5672967528c76dc7a638.svg";